import {priceListService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      priceListService: undefined
    };
  },
  created: function() {
    this.priceListService = priceListService;
  }
};
